import { useQuery } from '@tanstack/react-query';
import { ispApi } from '@/api/legacy/isp';

const PANEL_REFETCH_INTERVAL = 5_000; // 5 seconds when panel is open
const BACKGROUND_REFETCH_INTERVAL = 5 * 60_000; // 5 minutes in background

/**
 * Hook to fetch ISP status (down internet connections)
 * @param panelOpen - when true, refetches every 5 seconds
 */
export function useISPStatus(panelOpen = false) {
  return useQuery({
    queryKey: ['isp-status'],
    queryFn: () => ispApi.getStatus(),
    staleTime: panelOpen ? 0 : 60_000,
    refetchInterval: panelOpen ? PANEL_REFETCH_INTERVAL : BACKGROUND_REFETCH_INTERVAL,
  });
}

export { PANEL_REFETCH_INTERVAL };
